import moment from 'moment';

// ISO-8601 date as sent by the backend: other formats are not dates to display (the app parses ISO only)
const ISO_DATE = /^\d{4}-\d{2}-\d{2}/;

// Optional "... since" date sent by the backend, null when absent, empty or invalid
export function parseSinceDate(value) {
    if (value instanceof Date) return isNaN(value) ? null : value;
    if (typeof value !== 'string' || !ISO_DATE.test(value)) return null;
    const date = new Date(value);
    return isNaN(date) ? null : date;
}

// Local date and time of the "... since <date>" texts, same format as the app
export function formatSinceDate(date) {
    return moment(date).format('DD/MM/YYYY HH:mm');
}
